import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import LevelMarkingInfo from './LevelMarkingInfo';
import MarkingUtils from '../../../../../../utils/marking.utils';
import TableCellStudent from '../GuttmanChart/TableCellStudent';

const TableRowViewLC = ({
  student,
  lcs,
  levels,
  index,
  currentCurriculum,
  size = 30,
  isLoading,
  completed = 'completedTeacher',
  onMarking = () => {},
  onContextMenu = () => {},
  minMarking,
  maxMarking,
  marking = [],
  dataHideLevels = {}
}) => {
  return (
    <TableRow key={`guttman-chart-table-student-${student._id}`}>
      <TableCellStudent student={student} index={index} />
      {lcs.map((lc) => {
        return MarkingUtils.sortGranularSteps(
          levels,
          lc.granularSteps.filter(
            (gs) =>
              gs.isLevel &&
              gs.definition &&
              (dataHideLevels[gs.levelId] !== undefined ? dataHideLevels[gs.levelId] : true)
          )
        )
          .reverse()
          .map((gs) => {
            const levelsData = levels.find((level) => level._id === gs.levelId);
            const markingData = marking.find((mk) => mk._id === gs?.[completed]) || {};
            return (
              <TableCell
                key={`guttman-chart-table-student-${student._id}-lc-${lc._id}-gs-${gs.id}`}
                style={{ padding: 0.5, width: size }}
              >
                <LevelMarkingInfo
                  isLoading={isLoading}
                  lc={lc}
                  level={{
                    gsId: gs.id,
                    levelId: gs.levelId,
                    definition: gs?.definition || '',
                    name: levelsData?.name || ''
                  }}
                  marking={{
                    studentId: student._id,
                    exists: true,
                    completed: gs?.[completed],
                    ...markingData
                  }}
                  size={size}
                  currentCurriculum={currentCurriculum}
                  onMarking={onMarking}
                  onContextMenu={onContextMenu}
                  minMarking={minMarking}
                  maxMarking={maxMarking}
                />
              </TableCell>
            );
          });
      })}
    </TableRow>
  );
};

export default TableRowViewLC;
